<template>
  <div class="flex h-full items-center text-xl">
    <NavBarTabsItem v-for="tab in tabsData" :key="tab.label" :tab="tab" />
    <NavBarTabsItemMore />
  </div>
</template>

<script setup>
const tabsData = [
  {
    label: '首页',
    to: '/'
  },
  {
    label: '欧洲游',
    to: '/travel-notes?area=11'
  },
  {
    label: '亚洲游',
    to: '/travel-notes?area=12'
  },
  {
    label: '澳洲游',
    to: '/travel-notes?area=15'
  },
  {
    label: '中东游',
    to: '/travel-notes?area=17'
  },
  {
    label: '非洲游',
    to: '/travel-notes?area=13'
  },
  {
    label: '美洲游',
    to: '/travel-notes?area=14'
  }
]
</script>

<style lang="scss" scoped></style>
